import { ChangeDetectorRef, NgZone, OnDestroy, Pipe, PipeTransform } from '@angular/core';

/**
 * Inline replacement for time-ago-pipe@1.3.2 TimeAgoPipe.
 * The npm package uses View Engine constructor DI (no decorators), which breaks
 * in Angular 16 Ivy when subclassed — ngZone arrives undefined.
 * This pipe injects ChangeDetectorRef and NgZone directly using proper Ivy DI.
 */
@Pipe({
    name: 'timeAgo', pure: false,
    standalone: false
})
export class TimeAgoExtendsPipePipe implements PipeTransform, OnDestroy {
  private timer: any = null;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  transform(value: string): string {
    this.removeTimer();
    const d = new Date(value);
    const now = new Date();
    const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000));
    const timeToUpdate = Number.isNaN(seconds) ? 1000 : this.getSecondsUntilUpdate(seconds) * 1000;

    this.timer = this.ngZone.runOutsideAngular(() => {
      if (typeof window !== 'undefined') {
        return window.setTimeout(() => {
          this.ngZone.run(() => this.changeDetectorRef.markForCheck());
        }, timeToUpdate);
      }
      return null;
    });

    const minutes = Math.round(Math.abs(seconds / 60));
    const hours   = Math.round(Math.abs(minutes / 60));
    const days    = Math.round(Math.abs(hours / 24));
    const months  = Math.round(Math.abs(days / 30.416));
    const years   = Math.round(Math.abs(days / 365));

    if (Number.isNaN(seconds))  { return ''; }
    if (seconds <= 45)          { return 'a few seconds ago'; }
    if (seconds <= 90)          { return 'a minute ago'; }
    if (minutes <= 45)          { return minutes + ' minutes ago'; }
    if (minutes <= 90)          { return 'an hour ago'; }
    if (hours <= 22)            { return hours + ' hours ago'; }
    if (hours <= 36)            { return 'a day ago'; }
    if (days <= 25)             { return days + ' days ago'; }
    if (days <= 45)             { return 'a month ago'; }
    if (days <= 345)            { return months + ' months ago'; }
    if (days <= 545)            { return 'a year ago'; }
    return years + ' years ago';
  }

  ngOnDestroy(): void {
    this.removeTimer();
  }

  private removeTimer(): void {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  private getSecondsUntilUpdate(seconds: number): number {
    const min = 60, hr = min * 60, day = hr * 24;
    if (seconds < min)  { return 2; }
    if (seconds < hr)   { return 30; }
    if (seconds < day)  { return 300; }
    return 3600;
  }
}
